import React from 'react';
import classNames from 'classnames';
import styles from './AssessmentTrends.module.scss';

function ItemBlock({
  paletteClassName,
  isLockedStyle,
  isTransientStyle,
  onMouseEnter,
  onClick,
  clearTransientFilter,
  questionSetKey,
  questionKey,
  children,
}) {
  return (
    <li>
      <div
        style={{ position: 'relative' }}
        className={classNames(paletteClassName, styles['question-selector'], {
          [styles.locked]: isLockedStyle,
          [styles.transient]: isTransientStyle,
          'palette-muted': !(isLockedStyle || isTransientStyle),
        })}
        onMouseEnter={() => onMouseEnter(questionSetKey, questionKey)}
        onClick={() => onClick(questionSetKey, questionKey)}
        onMouseLeave={clearTransientFilter}
      >
        <div>
          <svg
            height={4}
            width="100%"
            style={{ position: 'absolute', top: 0, left: 0 }}
          >
            <rect
              x={0}
              y={0}
              height={4}
              width="100%"
              className="palette-fill muted"
            />
          </svg>
          <h4 className="line-clamp-var" style={{ '--line-clamp': 5 }}>
            {children}
          </h4>
        </div>
      </div>
    </li>
  );
}

export default ItemBlock;
